import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import StatusDialog from './StatusDialog';

/**
 * Resultado de uma ação (salvar, excluir, inscrever...). Fechado quando `resultado` é null.
 *
 * - Sucesso: `{ sucesso: true, titulo, rotuloAcao?, onAcao? }` — o botão faz `onAcao`
 *   (ex.: ir pra lista) ou só fecha.
 * - Erro: `{ sucesso: false, mensagem }`.
 */
export default function ResultadoDialog({ resultado, onClose }) {
  const { t } = useTranslation();
  const titleId = 'resultado-dialog-title';

  if (resultado?.sucesso) {
    return (
      <StatusDialog
        open
        onClose={onClose}
        color="success"
        icon={<CheckCircleRoundedIcon />}
        title={resultado.titulo}
        titleId={titleId}
        actions={
          <Button variant="contained" sx={{ minWidth: 160 }} onClick={resultado.onAcao ?? onClose}>
            {resultado.rotuloAcao ?? t('Close')}
          </Button>
        }
      />
    );
  }

  return (
    <StatusDialog
      open={Boolean(resultado)}
      onClose={onClose}
      color="error"
      icon={<ErrorRoundedIcon />}
      title={t('Occured an Error')}
      description={resultado?.mensagem}
      titleId={titleId}
      actions={
        <Button variant="outlined" color="error" sx={{ minWidth: 160 }} onClick={onClose}>
          {t('Close')}
        </Button>
      }
    />
  );
}
